import { ToolIdType } from '@adsk/alloy-provider';

export function toolIdToTranslatedKey(toolId: ToolIdType): string {
  const snakeCaseKeyToolId = toolId.replace(/[A-Z]/g, (match) => `_${match}`);
  const translationKey = `${snakeCaseKeyToolId.toUpperCase()}_TITLE`;

  return translationKey;
}
